import _ from 'lodash';
import 'slick-carousel/slick/slick';

import components from './components';
import App from './classes/app';

import '../scss/frontend.scss';
import { ComponentType } from './types/app-types';

function registerComponent(type: ComponentType, container: HTMLElement) {
  if (_.isFunction(components[type])) {
    const component = new components[type](type, container);
    App.addComponent(component);
  }
}

const containers = document.querySelectorAll<HTMLElement>(`[data-component-type]`);
containers.forEach(container => {
  const type = container.dataset.componentType as ComponentType;
  registerComponent(type, container);
});

const storeLocators = document.querySelectorAll<HTMLElement>('#wpsl-wrap');
storeLocators.forEach(container => {
  registerComponent('store-locator', container);
});
